export const ROUTES = {
  HOME: "/",
  AFFILIATES: "/affiliates",
  BLOG: "/blog",
};
